import { Comercio } from "./comercio"
import { Morador } from "./morador"

export class CadastroMoradorRequest {
    morador: Morador
    comercio?: Comercio = null
}
